import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsCommunication } from "@/models/admin/warrantsCommunication/warrantsCommunication"
import { IWarrantsCommunication } from "@/models/admin/warrantsCommunication/warrantsCommunication.types"

/**
 * A single `warrants_communications` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Communications` row; kept as a narrow type so
 * the parser only depends on the columns it actually reads.
 */
export type WarrantsCommunicationRaw = {
  id: number
  group_id: number
  comms_id?: string | null
  type: string
  delivery_status: string
  delivery_external_status?: string | null
  parent_priority_level: number
  error_description?: string | null
  created_at: string
  deleted_at?: string | null
}

export const WarrantsCommunicationParser: IParser<
  IWarrantsCommunication,
  WarrantsCommunicationRaw
> = {
  toDomain(data) {
    try {
      // Hasura timestamp columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsCommunication(
        data.id,
        data.group_id,
        data.comms_id ?? null,
        data.type,
        data.delivery_status,
        data.delivery_external_status ?? null,
        data.parent_priority_level,
        data.error_description ?? null,
        dayjsUTC(data.created_at),
        data.deleted_at ? dayjsUTC(data.deleted_at) : null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
